import { FC } from 'react';
import { vars } from '@croquiscom-pvt/zds/dist/tokens';
import { css, Global } from '@emotion/react';
import styled from '@emotion/styled';

import { web_max_width } from '@common/styles';

interface Props {
  is_selected?: boolean;
  support_dark_mode?: boolean;
}

export const Layout: FC<React.PropsWithChildren<Props>> = ({ is_selected, support_dark_mode, children }) => {
  return (
    <>
      <Global styles={store_home_style} />
      <Wrap is_selected={is_selected} support_dark_mode={support_dark_mode}>
        {children}
      </Wrap>
    </>
  );
};

const Wrap = styled.main<{ is_selected?: boolean; support_dark_mode?: boolean }>`
  max-width: ${web_max_width}px;
  min-height: 100vh;
  margin: 0 auto;
  background-color: ${vars.color.backgroundSurface};
  ${({ is_selected }) =>
    is_selected && `--zds-component-product-card-metadata-price-discount-percent-text-color: #ff4c34;`}
`;

const store_home_style = css`
  html {
    background: ${vars.color.backgroundSurface};
  }

  body {
    background: none;
  }
`;
